<section class="flex flex-col mx-auto w-full max-w-7xl px-0 sm:px-6 lg:px-8 mt-8">

  <div>

    <div>

      <!-- Page 1 -->
      <div *ngIf="page === 1">

        <div class="grid grid-cols-2 gap-6 mb-6">

          <div class="flex justify-center items-center bg-gray-50 rounded-xl p-6">
            <p class="text-secondary">
              Many times, sales job has counterintuitive aspects, and there is a lot of research of what can help us perform better in sales and how we can improve.
            </p>
          </div>

          <div class="flex justify-center items-center bg-gray-50 rounded-xl p-6">
            <p class="text-secondary">
              While we are born with some personality traits, during our life we go through continuous learning and transformation processes that help us evolve and become better at what we do.
            </p>
          </div>

          <div class="flex justify-center items-center bg-gray-50 rounded-xl p-6">
            <p class="text-secondary">
              At SalesOMMO we believe that evaluating yourself is the first step of a journey that can help you improve and become better at what you do, please start below.
            </p>
          </div>

          <!--
          <div class="hidden">

            <div *ngIf="!showVideo" class="relative">
              <img src="/assets/images/psy-testing.png" alt="PSY Testing" class="w-full rounded-lg" />
              <button (click)="playVideo()" class="absolute inset-0 flex items-center justify-center">
                <svg class="w-16 h-16 text-white" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5v14l11-7L8 5z"></path>
                </svg>
              </button>
            </div>



            <div *ngIf="showVideo" class="relative">
              <iframe
                width="100%"
                height="315"
                [src]="videoUrl | safe"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>

          </div>
          -->

        </div>

        <!-- Blue Card -->
        <div class="grid grid-cols-2 gap-6">

          <div class="blue-card p-6">

            <div class="mb-6">
              <h2 class="text-lg font-semibold">You work in sales: what are your P’s?</h2>
              <p class="text-secondary text-sm">A test designed to uncover you 4P’s - model by SaleOMMO</p>
            </div>

            <p class="text-secondary mb-6">
              Evaluate your empathic concern and perspective taking abilities in world that is extremely
              competitive and find out where you are, and get further tips to improve performance that are
              adjusted to your personal profile.
            </p>

            <button *ngIf="!user?.test_code" type="button" class="btn btn-blue text-center w-60" (click)="nextPage(2, 1)">Take the test</button>
            <button *ngIf="user?.test_code" type="button" class="btn btn-blue text-center w-60" (click)="viewReport()">See Report</button>

          </div>

          <div class="blue-card p-6">

            <div class="mb-6">
              <h2 class="text-lg font-semibold">How good are you at “reading” your clients?</h2>
              <p class="text-secondary text-sm">A test designed to help you uncover more traits that are essentials in your sales job.</p>
            </div>

            <p class="text-secondary mb-6">
              Evaluate your ability to detect non-verbal clues, to build rapport, and to take a bird’s eye view
              when needed. How good are you at shaping customer interactions and how can you be better at
              it? Find out where you are, and get further recommendations to improve performance.
            </p>

            <button disabled="disabled" type="button" class="btn btn-blue text-center w-60 disabled:bg-opacity-90">Coming Soon</button>

          </div>

        </div>

      </div>
      <!-- / Page 1 -->

      <!-- Page 2 -->
      <div *ngIf="page === 2">

        <!-- PSY Testing -->
        <h1 class="text-md font-semibold tracking-tight text-secondary dark:text-primary-100 mb-3">What’s your P as salesPerson?</h1>
        <!-- / PSY Testing -->

        <!-- Screen 1 -->
        <div *ngIf="screen === 1">

          <p class="text-secondary mb-9">
            The following statements inquire about your thoughts and feelings in a variety of situations. For each item, indicate how well it describes you by choosing the appropriate letter on the scale bellow: A, B, C, D, or E. When you have decided on your answer, click on the corresponding letter. READ EACH ITEM CAREFULLY BEFORE RESPONDING. Answer as honestly as you can. Thank you.
          </p>

          <p class="text-secondary mb-9">
            The following statements inquire about your thoughts and feelings in a variety of situations. For each item, indicate how well it describes you by choosing the appropriate letter on the scale bellow: A, B, C, D, or E. When you have decided on your answer, click on the corresponding letter. READ EACH ITEM CAREFULLY BEFORE RESPONDING. Answer as honestly as you can. Thank you. 
            The answers to these questions are confidential and they will not be shared with third parties. If you would like to support the progress of science as we are trying to understand better how we can help salespeople get more job satisfaction and increase their sales performance, please give us your consent to use these results for research purposes, without associating them with any personal identification data related to you.  
          </p>

          <!-- Checkbox -->
          <div class="mb-4">
            <label class="inline-flex items-center">
              <input type="checkbox" [(ngModel)]="isConsentGiven" class="h-4 w-4 rounded border-gray-300 text-blue-royal focus:ring-blue-royal">
              <span class="text-secondary/75 text-sm ml-2">I consent to the use of my assessment results for research purposes, anonymously, without any other data that could permit my identification.</span>
            </label>
          </div>

          <!-- Take test button -->
          <button class="btn btn-blue text-center w-60 mt-6 disabled:bg-opacity-90" [disabled]="!isConsentGiven" (click)="generatePsyTest()">Take test</button>

        </div>
        <!-- / Screen 1 -->

        <!-- Screen 2 -->
        <div *ngIf="screen === 2" class="px-4 lg:p-6">

          <div class="mx-auto max-w-5xl mb-20">

            <!-- Progress -->
            <div class="progress-container">
              <mat-progress-bar mode="determinate" [value]="progress" class="progress-bar"></mat-progress-bar>
              <span class="progress-percentage" [style.left.%]="progress" [style.opacity]="progress > 0 ? 1 : 0">
                {{ progress }}%
              </span>
            </div>
            <!-- / Progress -->

          </div>

          <!-- Display only the current item -->
          <div *ngIf="currentItem" class="mx-auto max-w-5xl items-center mb-12">

            <!-- Display item counter -->
            <p class="text-sm text-left text-gray-500 mb-4 hidden">
              Question {{ itemIndex + 1 }} of {{ totalItems }}
            </p>

            <!-- Item question text -->
            <div class="h-12 max-h-12 flex justify-start items-center mb-12">
              <p class="font-semibold">{{ currentItem.name }}</p>
            </div>

            <div class="grid grid-cols-3 gap-9 mb-12">

              <!-- Left label for description scale -->
              <div class="flex justify-center">
                <p class="text-secondary">
                  <span class="text-secondary font-semibold">1</span> = Does not <br /> describe me very well
                </p>
              </div>

              <!-- Answer selection options -->
              <div class="flex justify-center space-x-3">
                <!-- Loop through answer choices (1-5) -->
                <ng-container *ngFor="let answer of [1, 2, 3, 4, 5]">
                  <button type="button"
                          class="flex justify-center items-center w-12 h-12 rounded-md text-white text-lg font-medium hover:opacity-90"
                          [ngClass]="{
                            'bg-[#FC8226]': getAnswer(currentItem.id) === answer,
                            'bg-[#d5ddff]': getAnswer(currentItem.id) !== answer && answer === 1,
                            'bg-[#B7C4FF]': getAnswer(currentItem.id) !== answer && answer === 2,
                            'bg-[#91A7FF]': getAnswer(currentItem.id) !== answer && answer === 3,
                            'bg-[#6989FF]': getAnswer(currentItem.id) !== answer && answer === 4,
                            'bg-[#426BF7]': getAnswer(currentItem.id) !== answer && answer === 5
                          }"
                          (click)="setAnswer(currentItem.id, answer)">
                    {{ answer }}
                  </button>
                </ng-container>
              </div>

              <!-- Right label for description scale -->
              <div class="flex justify-center">
                <p class="text-secondary">
                  <span class="text-secondary font-semibold">5</span> = Describes me <br /> very well
                </p>
              </div>
            </div>

            <div class="flex items-center" [ngClass]="{'justify-end': itemIndex === 0, 'justify-between': itemIndex > 0}">
              <button *ngIf="itemIndex > 0" class="btn btn-blue text-center w-24" (click)="previousItem()">Previous</button>
              <button *ngIf="!isLastItem" class="btn btn-blue text-center w-24 disabled:bg-opacity-90" (click)="nextItem()" [disabled]="!isAnswerSelected">Next</button>
            </div>

          </div>

          <!-- Progress bar and Save All Answers button -->
          <div class="mx-auto max-w-5xl flex justify-center mt-6">

            <button *ngIf="isLastItem" class="btn btn-blue text-center w-60 mt-6" (click)="saveTestAnswers()">
              Save All Answers
            </button>

          </div>


        </div>
        <!-- / Screen 2 -->

        <!-- Screen 3 -->
        <div *ngIf="screen === 3" class="px-4 lg:p-6">

          <p class="flex justify-center font-semibold mb-6">
            Congratulations!
          </p>

          <p class="flex justify-center text-sm mb-9">Congrats, infos about the report and where they can find it.</p>

          <div class="mx-auto max-w-5xl flex justify-center mb-9">
            <button type="button" class="btn btn-blue text-center w-60 mt-6" (click)="viewReport()">See Report</button>
          </div>

          <div class="mx-auto max-w-5xl flex justify-center">
            <a href="/psy-testing" class="btn btn-blue text-center w-60">Back to PSY Testing</a>
          </div>

        </div>

      </div>
      <!-- / Page 2 -->

    </div>

  </div>

</section>

<app-subscription-banner></app-subscription-banner>
